import { ArrowBackIcon, ArrowForwardIcon, TimeIcon } from '@/components/icons/Icon';
import { Box, IconButton, Text } from "@chakra-ui/react";
import { addDays, addMonths, addWeeks, endOfWeek, format, getWeek, Locale, startOfWeek, subDays, subMonths, subWeeks } from "date-fns";
import { Tooltip } from "@/components/ui/tooltip";
import { TimesheetView } from "./TimesheetCalendarUtils";

interface MonthNavigationProps {
    currentMonth: Date;
    setCurrentMonth: (date: Date) => void;
    language: Locale;
    view?: TimesheetView;
}

const MonthNavigation = ({ currentMonth, setCurrentMonth, language, view = "month" }: MonthNavigationProps) => {
    const label = (() => {
        if (view === "day") {
            return format(currentMonth, "EEEE, d. MMMM yyyy", { locale: language });
        }

        if (view === "week") {
            const weekStart = startOfWeek(currentMonth, { locale: language });
            return `KW ${getWeek(currentMonth, { locale: language })}: ${format(weekStart, "d. MMM yyyy", { locale: language })}`;
        }

        return format(currentMonth, "MMMM yyyy", { locale: language });
    })();

    const previous = () => {
        if (view === "day") {
            setCurrentMonth(subDays(currentMonth, 1));
        } else if (view === "week") {
            setCurrentMonth(subWeeks(currentMonth, 1));
        } else {
            setCurrentMonth(subMonths(currentMonth, 1));
        }
    };

    const next = () => {
        if (view === "day") {
            setCurrentMonth(addDays(currentMonth, 1));
        } else if (view === "week") {
            setCurrentMonth(addWeeks(currentMonth, 1));
        } else {
            setCurrentMonth(addMonths(currentMonth, 1));
        }
    };

    return (
        <Box display="flex" alignItems="center" gap={2} minW={0} w='24rem' maxW='full' h={{ base: '4.5rem', md: '3rem' }} flexShrink={0}>
            <IconButton
                variant='outline'
                size='sm'
                colorPalette='blue'
                aria-label='Vorheriger Zeitraum'
                onClick={previous}
            ><ArrowBackIcon /></IconButton>
            <Text minW={0} flex="1" fontSize='lg' lineHeight='shorter' fontWeight={'bold'} textAlign={'center'}>{label}</Text>
            <IconButton
                variant='outline'
                size='sm'
                colorPalette='blue'
                aria-label='Nächster Zeitraum'
                onClick={next}
            ><ArrowForwardIcon /></IconButton>
            <Tooltip content='Heute'>
                <IconButton
                    variant='outline'
                    size='sm'
                    colorPalette='blue'
                    aria-label='Heute'
                    ml={{ base: 0, md: 3 }}
                    onClick={() => setCurrentMonth(new Date())}
                ><TimeIcon /></IconButton>
            </Tooltip>
        </Box>
    );
};

export default MonthNavigation;
